"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
var _ListItemIcon = _interopRequireDefault(require("../../ListItemIcon/ListItemIcon"));
var _Stack = _interopRequireDefault(require("../../Stack"));
var _HintTooltip = _interopRequireDefault(require("./HintTooltip"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Option = function Option(_ref) {
  var isGrouped = _ref.isGrouped,
    showCheckbox = _ref.showCheckbox,
    children = _ref.children,
    optionInfo = _ref.optionInfo,
    optionIconInfo = _ref.optionIconInfo,
    selected = _ref.selected,
    disabled = _ref.disabled;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
    children: [isGrouped ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        paddingLeft: '30px'
      }
    }) : null, showCheckbox && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon["default"], {
      style: {
        minWidth: 28
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox["default"], {
        edge: 'start',
        checked: selected,
        tabIndex: -1,
        disableRipple: true,
        color: 'primary',
        "data-cy-role": 'multiSelectCheckbox',
        disabled: disabled
      })
    }), children, optionInfo ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
      pl: 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_HintTooltip["default"], {
        info: optionInfo,
        children: optionIconInfo
      })
    }) : null]
  });
};
var _default = exports["default"] = Option;